import React from 'react';

import {
  StyledInformationBox,
  StyledInformationBoxText,
} from './InformationBox.styled';

interface InformationBoxProps {
  visible?: boolean;
  children?: React.ReactNode;
}

export const InformationBox = ({
  visible = true,
  children,
}: InformationBoxProps) => {
  return visible ? (
    <StyledInformationBox>
      <StyledInformationBoxText>{children}</StyledInformationBoxText>
    </StyledInformationBox>
  ) : null;
};
